import React, { useRef } from "react";
import { Box, CircularProgress, Grid } from "@material-ui/core";
import { useQuery, gql } from "@apollo/client";
import { useParams } from "react-router-dom";

import { Navbar } from "./navbar";

import { Overview } from "./components/overview";
import { ReportCard } from "./components/reportCard";
import { PopularMajors } from "./components/popularMajors";
import { About } from "./components/about";
import { Rankings } from "./components/ranking";
import { Admission } from "./components/admissions";
// import { Cost } from "./components/cost";
import { Academics } from "./components/academics";
// import { Majors } from "./components/majors";
// import { Students } from "./components/students";
import { CampusLife } from "./components/campusLife";
// import { AfterCollege } from "./components/afterCollege";
import { Finance } from "./components/finance";
import { SportsDetails } from "./components/sports";

import {
  Info,
  GroupWork,
  PeopleAlt,
  School,
  Assignment,
  FilterList,
  Money,
  PersonPin,
  Sports,
} from "@material-ui/icons";

const GET_COLLEGE_INFO = gql`
  query Query($getCollegeInfoCollegeId: String) {
    getCollegeInfo(collegeId: $getCollegeInfoCollegeId)
  }
`;

export function CollegeDetails() {
  const { collegeId } = useParams();

  const { loading, error, data } = useQuery(GET_COLLEGE_INFO, {
    fetchPolicy: "cache-first",
    variables: {
      getCollegeInfoCollegeId: collegeId,
    },
  });

  let collegeDetails =
    !loading && !error ? JSON.parse(data.getCollegeInfo) : {};

  const popularMajorItems = [{ title: "Hello", value: 123456 }];

  const menuList = {
    about: {
      title: "About",
      ref: useRef(),
      icon: <Info />,
      component: <About data={collegeDetails} />,
    },

    overview: {
      title: "Overview",
      ref: useRef(),
      icon: <GroupWork />,
      component: <Overview data={collegeDetails} />,
    },

    reportCard: {
      title: "Report Card",
      ref: useRef(),
      component: <ReportCard data={collegeDetails} />,
    },

    popularMajors: {
      title: "Popular Major",
      ref: useRef(),
      icon: <PeopleAlt />,
      component: (
        <PopularMajors list={popularMajorItems} data={collegeDetails} />
      ),
    },

    admissions: {
      title: "Admissions",
      ref: useRef(),
      icon: <School />,
      component: <Admission data={collegeDetails} />,
    },

    academics: {
      title: "Academics",
      ref: useRef(),
      icon: <Assignment />,
      component: <Academics data={collegeDetails} />,
    },

    ranking: {
      title: "Rankings",
      ref: useRef(),
      icon: <FilterList />,
      mdCol: 12,
      component: <Rankings data={collegeDetails} />,
    },

    finance: {
      title: "Finance",
      ref: useRef(),
      icon: <Money />,
      component: <Finance data={collegeDetails} />,
    },

    campusLife: {
      title: "Campus Life",
      ref: useRef(),
      icon: <PersonPin />,
      component: <CampusLife data={collegeDetails} />,
    },

    sports: {
      title: "Sports",
      ref: useRef(),
      icon: <Sports />,
      component: <SportsDetails data={collegeDetails} />,
    },

    // cost: {
    //   title: "Cost",
    //   ref: useRef(),
    //   component: <Cost data={collegeDetails} />,
    // },
    // students: {
    //   title: "Students",
    //   ref: useRef(),
    //   component: <Students data={collegeDetails} />,
    // },
    // afterCollege: {
    //   title: "After College",
    //   ref: useRef(),
    //   component: <AfterCollege data={collegeDetails} />,
    // },
  };

  return (
    <>
      {" "}
      {loading ? (
        <Box className="text-center">
          <CircularProgress style={{ color: "#3699FF" }} />
        </Box>
      ) : error ? (
        <Box className="text-center">Something went wrong</Box>
      ) : (
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <Box
              style={{
                position: "sticky",
                top: 80,
              }}
            >
              <Navbar menuList={menuList} data={collegeDetails} />
            </Box>
          </Grid>
          <Grid item sm>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <Grid container spacing={3}>
                  <Grid item sm>
                    <Box mb={2} ref={menuList.about.ref}>
                      {menuList.about.component}
                    </Box>
                    <Box ref={menuList.overview.ref}>
                      {menuList.overview.component}
                    </Box>
                  </Grid>
                  <Grid item sm>
                    <Box mb={2} ref={menuList.reportCard.ref}>
                      {menuList.reportCard.component}
                    </Box>
                    <Box ref={menuList.popularMajors.ref}>
                      {menuList.popularMajors.component}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={3}>
                  {[
                    "admissions",
                    "academics",
                    "ranking",
                    "finance",
                    "campusLife",
                    "sports",
                  ].map((key, index) => (
                    <Grid
                      item
                      md={menuList[key].mdCol || 6}
                      key={index}
                      ref={menuList[key].ref}
                    >
                      {menuList[key].component}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
